import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReportsViewComponent } from './view/reports-view/reports-view.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { SalesGraphComponent } from './view/graphs/sales-graph/sales-graph.component';

import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { GraphTotalInfoComponent } from './view/graph-total-info/graph-total-info.component';
import { MiscModule } from 'projects/core/src/lib/misc/misc.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { AcadiaGraphComponent } from './view/graphs/acadia-graph/acadia-graph.component';
import { CalendarModule } from 'primeng/calendar';
import { DougnutsViewComponent } from './view/graphs/dougnuts-view/dougnuts-view.component';
import { DoughnutChartComponent } from './view/graphs/dougnuts-view/doughnut-chart/doughnut-chart.component';
import { MatRippleModule } from '@angular/material/core';
import { BarsChartViewComponent } from './view/graphs/bars-chart-view/bars-chart-view.component';
import { PaginatorModule } from 'primeng/paginator';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { GraphsViewComponent } from './view/graphs-view/graphs-view.component';
import { CabinetsComplexityViewComponent } from './view/cabinets-complexity-view/cabinets-complexity-view.component';
import {
  CabinetReportsViewComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-complexity-reports/project-complexity-reports-view/cabinet-reports-view.component';
import {
  ProjectComplexityCabinetsTableComponent
} from 'projects/app-misc/src/app/modules/reports/view/project-complexity-reports/project-complexity-reports-view/project-complexity-cabinets-table/project-complexity-cabinets-table.component';
import { ProjectComplexityViewComponent } from './view/project-complexity-view/project-complexity-view.component';
import { ProjectOverallPriceViewComponent } from './view/project-overall-price-view/project-overall-price-view.component';
import { ProjectOverallPriceTableComponent } from './view/project-overall-price-view/project-overall-price-table/project-overall-price-table.component';
import { CreateProjectReportDialogComponent } from './view/project-overall-price-view/create-project-report-dialog/create-project-report-dialog.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProjectStatReportsComponent } from './view/project-stat-reports/project-stat-reports.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ProjectStatFilterComponent } from './view/project-stat-reports/project-stat-filter/project-stat-filter.component';
import {FileUploadModule} from 'primeng/fileupload';
import { EstimateEditorDialogComponent } from './view/estimate-editor-dialog/estimate-editor-dialog.component';
import { ConfirmationService } from 'primeng/api';
import {SalespersonTransactionsDialogComponent} from './view/salesperson-transactions-dialog/salesperson-transactions-dialog.component';
import {ScheduleEstimatesDialogComponent} from './view/schedule-estimates-dialog/schedule-estimates-dialog.component';


@NgModule({
  declarations: [
    ReportsViewComponent,
    SalesGraphComponent,
    GraphTotalInfoComponent,
    SalespersonTransactionsDialogComponent,
    AcadiaGraphComponent,
    DougnutsViewComponent,
    DoughnutChartComponent,
    BarsChartViewComponent,
    CabinetReportsViewComponent,
    ProjectComplexityCabinetsTableComponent,
    GraphsViewComponent,
    CabinetsComplexityViewComponent,
    ProjectComplexityViewComponent,
    ProjectOverallPriceViewComponent,
    ProjectOverallPriceTableComponent,
    CreateProjectReportDialogComponent,
    ProjectStatReportsComponent,
    ProjectStatFilterComponent,
    EstimateEditorDialogComponent,
    ScheduleEstimatesDialogComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MatRippleModule,
        MatButtonModule,
        ChartModule,
        DropdownModule,
        MultiSelectModule,
        MatIconModule,
        MiscModule,
        MatDialogModule,
        CalendarModule,
        PaginatorModule,
        AccordionModule,
        TableModule,
        InputNumberModule,
        InputTextModule,
        MatProgressSpinnerModule,
        ConfirmDialogModule,
        FileUploadModule

    ],
  entryComponents: [
    SalespersonTransactionsDialogComponent,
    EstimateEditorDialogComponent,
    ScheduleEstimatesDialogComponent
  ],
  providers: [
    ConfirmationService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class ReportsModule {
}
